import {Sprite, Texture} from 'pixi.js';
import {TextureUrlLoader} from '../../../../utils/TextureUrlLoader';

export class Logo extends Sprite
{
    private logoSprite: Sprite | undefined;

    constructor() {
        super();

        this.initialize();
    }

    private async initialize(): Promise<void> {
        let logoTexture: Texture | null = await TextureUrlLoader.load('/images/context-menu/ic_logo.svg');
        this.logoSprite = new Sprite(logoTexture!);
        this.logoSprite.alpha = 0.1;
        this.logoSprite.anchor.set(.5);
        this.logoSprite.scale.set(2);
        this.addChild(this.logoSprite);
    }
}
